import { render, staticRenderFns } from "./trainingList.vue?vue&type=template&id=f58b0544&scoped=true"
import script from "./trainingList.vue?vue&type=script&lang=js"
export * from "./trainingList.vue?vue&type=script&lang=js"
import style0 from "./trainingList.vue?vue&type=style&index=0&id=f58b0544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58b0544",
  null
  
)

export default component.exports